import { useEffect, useState } from "react";
import { Button, Input, Modal, Select, Spin, Tabs } from "antd";

import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";

// import { pageMode } from "../hospitalMapping";
import Icon from "@assets/icon_config";
import HospitalListTable from "../hospitalListTable/hospitalListTable";
import CaseManagerListTable from "../caseManagerTabel/caseManagerTable";
import PayorCaseManagerListTable from "../payorCaseManager/payorCaseManager";
import HospitalListCMService from "@services/hospital-list-and-case-manager.service";
import "./FacilityInfo.scss";
import { forEach, isEmpty } from "lodash";
import { PlusCircleOutlined } from "@ant-design/icons";
import classNames from "classnames";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from '@components/accessLevel'

type FacilityInfoProps = {
  facility?: string;
};

export enum tabKeyName {
  hospitalists = "1",
  hospitalCaseManager = "2",
  payerCaseManager = "3",
}

const { Option } = Select;

const FacilityInfo = ({ facility }: FacilityInfoProps) => {
  const [selectedCounty, setSelectedCounty] = useState<any>("");
  const [selectedHospitalGroup, setSelectedHospitalGroup] = useState<any>("");
  const [selectedFacilityType, setSelectedFacilityType] = useState<any>("");
  const [noFacilityErrorMesage, setNoFacilityErrorMesage] = useState(false);
  const [noFaciityName, setNoFaciityName] = useState("");

  return (
    <div className="hospitalList-component">
      <EditMode
        facility={facility}
        setSelectedCounty={setSelectedCounty}
        setSelectedHospitalGroup={setSelectedHospitalGroup}
        selectedFacilityType={selectedFacilityType}
        setSelectedFacilityType={setSelectedFacilityType}
        selectedHospitalGroup={selectedHospitalGroup}
        selectedCounty={selectedCounty}
        setNoFaciityName={setNoFaciityName}
        setNoFacilityErrorMesage={setNoFacilityErrorMesage}
      />
      <MappingTabs setSelectedCounty={setSelectedCounty} setSelectedHospitalGroup={setSelectedHospitalGroup} setSelectedFacilityType={setSelectedFacilityType} noFaciityName={noFaciityName} noFacilityErrorMesage={noFacilityErrorMesage}/>
    </div>
  );
};

const EditMode = (props: any) => {
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);
  // const isFacilityEditing = useHospitalMappingStore((state) => state.isFacilityEditing);
  // const setIsFacilityEditing = useHospitalMappingStore((state) => state.setIsFacilityEditing);
  // const isHospitalListLoading = useHospitalMappingStore((state) => state.isHospitalListLoading);
  // const setIsHospitalListLoading = useHospitalMappingStore((state) => state.setIsHospitalListLoading);
  const selectedHospitalListFacility = useGlobalInformationStore((state) => state.selectedHospitalListFacility);
  const setSelectedHospitalListFacility = useGlobalInformationStore((state) => state.setSelectedHospitalListFacility);
  const setIsFacilityUpdated = useHospitalMappingStore((state) => state.setIsFacilityUpdated);
  const isFacilityUpdated = useHospitalMappingStore((state) => state.isFacilityUpdated);
  // const availableFacilityOfCurrentMember = useHospitalMappingStore((state) => state.availableFacilityOfCurrentMember);
  // const isBackButtonDisplay = useHospitalMappingStore((state) => state.isBackButtonDisplay);

  const [isAddFacilityModalOpen, setIsAddFacilityModalOpen] = useState(false);
  const [isAddFacilityModalLoading, setIsAddFacilityModalLoading] = useState(false);
  const [dropDownIsSelectable, setDropDownIsSelectable] = useState(true);
  const [facilityOptionList, setFacilityOptionList] = useState<any[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<any>("");
  // const [selectedCounty, setSelectedCounty] = useState<any>("");
  // const [selectedHospitalGroup, setSelectedHospitalGroup] = useState<any>("");
  // const [selectedFacilityType, setSelectedFacilityType] = useState<any>("");
  const [facilityOptionListValues, setFacilityOptionListValues] = useState<any[]>([]);
  const [facilityDependentOption, setFacilityDependentOption] = useState<any>({});
  // const [isFacilityChange, setIsFacilityChange] = useState(false);
  const [addFacility, setAddFacility] = useState("");
  const [addCounty, setAddCounty] = useState("");
  const [addHospitalistGroup, setaddHospitalistGroup] = useState("");
  const [addTypeOfFacility, setaddTypeOfFacility] = useState("");
  const [dropdownEditEnabled, setDropdownEditEnabled] = useState(false);
  const [addFacilityFirstLoad, setAddFacilityFirstLoad] = useState<boolean>(true);

  useEffect(() => {
    console.log("EditMode.useEffect");
    //Service Calls
    //Fetching facility Options
    // setIsHospitalListLoading(true);
    // setIsFacilityChange(true);
    // setFacilityOptionList(facilityList.data.data);
    // setFacilityOptionListValues(facilityList.data.data.map((facilityOption: any) => facilityOption.facility_name).filter((filteredOptions:any) => !(filteredOptions===undefined || filteredOptions === null || filteredOptions === "") ));
    // if(props?.facility){
    //   let preSelectedFacilityObject = facilityList.data.data.filter((selectedFacility : any) => selectedFacility?.facility_name === props?.facility);
    //   if(preSelectedFacilityObject && preSelectedFacilityObject.length > 0) {
    //     setSelectedFacility(preSelectedFacilityObject[0]?.facility_name);
    //     setSelectedCounty(preSelectedFacilityObject[0]?.county_name);
    //     setSelectedHospitalGroup(preSelectedFacilityObject[0]?.hosplst_grp_name);
    //     setSelectedFacilityType(preSelectedFacilityObject[0]?.organization_name);
    //   }
    // }
    props.setNoFacilityErrorMesage(false);
    props.setNoFaciityName("");
    if (isEmpty(facilityOptionList)) {
      getFacility();
    } else {
      setFacilityListFunction(facilityOptionList);
    }
    if (currentpageMode === "edit" && isEmpty(facilityDependentOption)) {
      getFacilityDependentOption();
    }
    setDropdownEditEnabled(false);
    // setIsHospitalListLoading(false);
    // setIsFacilityChange(false);

    //Fetching Hospital List Data
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHospitalListFacility]);

  // useEffect(() => {
  // if(props?.facility){
  // let preSelectedFacilityObject = facilityList.data.data.filter((selectedFacility : any) => selectedFacility?.facility_name === props?.facility);
  // if(preSelectedFacilityObject && preSelectedFacilityObject.length > 0) {
  //   setSelectedFacility(preSelectedFacilityObject[0]?.facility_name);
  //   setSelectedCounty(preSelectedFacilityObject[0]?.county_name);
  //   setSelectedHospitalGroup(preSelectedFacilityObject[0]?.hosplst_grp_name);
  //   setSelectedFacilityType(preSelectedFacilityObject[0]?.organization_name);
  // } else {
  //   setSelectedFacility("");
  //   setSelectedCounty("");
  //   setSelectedHospitalGroup("");
  //   setSelectedFacilityType("");
  // }
  // getFacility();
  // }
  // },[selectedHospitalListFacility]);

  const getFacility = () => {
    console.log("EditMode.getFacility");
    HospitalListCMService.fetchFacilities("").subscribe({
      next: (v) => {
        // const response = v.data.data.data;
        setFacilityOptionList(v.data.data.data);
        setFacilityOptionListValues(
          v.data.data.data
            .map((facilityOption: any) => facilityOption.facility_name)
            .filter((filteredOptions: any) => !(filteredOptions === undefined || filteredOptions === null || filteredOptions === ""))
        );
        setFacilityListFunction(v.data.data.data);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const setFacilityListFunction = (facilityListObject: any) => {
    console.log("EditMode.setFacilityListFunction");
    // let facilityName: string;
    // if (!(selectedHospitalListFacility === undefined || selectedHospitalListFacility === null || selectedHospitalListFacility === "")) {
    //   facilityName = selectedHospitalListFacility;
    // } else {
    //   facilityName = "";
    //   setSelectedFacility("");
    //   props.setSelectedCounty("");
    //   props.setSelectedHospitalGroup("");
    //   props.setSelectedFacilityType("");
    // }
    // if (facilityName !== "") {
    //   let preSelectedFacilityObject = facilityListObject?.filter((selectedFacilityObjItem: any) => selectedFacilityObjItem?.facility_name.toLowerCase() === selectedHospitalListFacility.toLowerCase());
    //   if (preSelectedFacilityObject && preSelectedFacilityObject.length > 0) {
    //     setSelectedFacility(preSelectedFacilityObject[0]?.facility_name);
    //     props.setSelectedCounty(preSelectedFacilityObject[0]?.county_name);
    //     props.setSelectedHospitalGroup(preSelectedFacilityObject[0]?.hosplst_grp_name);
    //     props.setSelectedFacilityType(preSelectedFacilityObject[0]?.organization_name);
    //   } else {
    //     setSelectedFacility("");
    //     props.setSelectedCounty("");
    //     props.setSelectedHospitalGroup("");
    //     props.setSelectedFacilityType("");
    //   }
    // }

    // if (currentpageMode === 'edit' && facilityListObject.length >= 0 && selectedHospitalListFacility === "") {
    //   setSelectedHospitalListFacility(facilityListObject[0]?.facility_name);
    //   setSelectedFacility(facilityListObject[0]?.facility_name);
    //   props.setSelectedCounty(facilityListObject[0]?.county_name);
    //   props.setSelectedHospitalGroup(facilityListObject[0]?.hosplst_grp_name);
    //   props.setSelectedFacilityType(facilityListObject[0]?.organization_name);
    // }

    // if (currentpageMode === 'read' && facilityListObject.length >= 0 && selectedHospitalListFacility === "") {
    //   setSelectedHospitalListFacility(facilityListObject[0]?.facility_name);
    //   setSelectedFacility(facilityListObject[0]?.facility_name);
    //   props.setSelectedCounty(facilityListObject[0]?.county_name);
    //   props.setSelectedHospitalGroup(facilityListObject[0]?.hosplst_grp_name);
    //   props.setSelectedFacilityType(facilityListObject[0]?.organization_name);
    // }

    let facilityName: string = "";
    if (!(selectedHospitalListFacility === undefined || selectedHospitalListFacility === null || selectedHospitalListFacility === "")) {
      facilityName = selectedHospitalListFacility;
    }

    if (facilityName !== "") {
      let preSelectedFacilityObject = facilityListObject?.filter((selectedFacilityObjItem: any) => selectedFacilityObjItem?.facility_name.toLowerCase() === selectedHospitalListFacility.toLowerCase());
      if (currentpageMode === "edit" && facilityListObject.length >= 0 && (selectedHospitalListFacility === "" || preSelectedFacilityObject.length === 0)) {
        setSelectedHospitalListFacility(facilityListObject[0]?.facility_name);
        setSelectedFacility(facilityListObject[0]?.facility_name);
        props.setSelectedCounty(facilityListObject[0]?.county_name);
        props.setSelectedHospitalGroup(facilityListObject[0]?.hosplst_grp_name);
        props.setSelectedFacilityType(facilityListObject[0]?.organization_name);
      } else if (preSelectedFacilityObject && preSelectedFacilityObject.length > 0) {
        setSelectedFacility(preSelectedFacilityObject[0]?.facility_name);
        props.setSelectedCounty(preSelectedFacilityObject[0]?.county_name);
        props.setSelectedHospitalGroup(preSelectedFacilityObject[0]?.hosplst_grp_name);
        props.setSelectedFacilityType(preSelectedFacilityObject[0]?.organization_name);
      } else {
        props.setNoFacilityErrorMesage(true);
        props.setNoFaciityName(selectedHospitalListFacility);
        setSelectedFacility("");
      }
    } else {
      setSelectedHospitalListFacility(facilityListObject[0]?.facility_name);
      setSelectedFacility(facilityListObject[0]?.facility_name);
      props.setSelectedCounty(facilityListObject[0]?.county_name);
      props.setSelectedHospitalGroup(facilityListObject[0]?.hosplst_grp_name);
      props.setSelectedFacilityType(facilityListObject[0]?.organization_name);
    }
  };

  const getFacilityDependentOption = () => {
    HospitalListCMService.fetchFacilityDependentOptions().subscribe({
      next: (v) => {
        // console.log(v.data.data.data);
        setFacilityDependentOption(v.data.data.data);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const disableEditableDropDown = () => {
    if (currentpageMode === "edit") {
      setDropDownIsSelectable(false);
      setTimeout(() => {
        setDropDownIsSelectable(true);
      }, 3000);
    }
  };

  const onFacilityChange = (facility: any) => {
    let SelectedfaciltyObj = facilityOptionList?.filter((facilityObj: any) => facility.toLowerCase() === facilityObj?.facility_name.toLowerCase());
    if (SelectedfaciltyObj && SelectedfaciltyObj?.length > 0) {
      setSelectedHospitalListFacility(SelectedfaciltyObj[0]?.facility_name);
      setSelectedFacility(SelectedfaciltyObj[0]?.facility_name);
      props.setSelectedCounty(SelectedfaciltyObj[0]?.county_name);
      props.setSelectedHospitalGroup(SelectedfaciltyObj[0]?.hosplst_grp_name);
      props.setSelectedFacilityType(SelectedfaciltyObj[0]?.organization_name);
    }
  };

  const onCountyChange = (county: any) => {
    // console.log("county lst updated");
    // setSelectedCounty(county);
    updateFacilityGroup(props.setSelectedCounty, county, "county", props.selectedCounty);
  };

  const onHosptalGroupChange = (hospitalGroup: any) => {
    // console.log("group lst updated");
    // setSelectedHospitalGroup(hospitalGroup);
    updateFacilityGroup(props.setSelectedHospitalGroup, hospitalGroup, "hospital-group", props.selectedHospitalGroup);
  };

  const onFacilityTypeChange = (facilityType: any) => {
    // console.log("type lst updated");
    // setSelectedFacilityType(facilityType);
    updateFacilityGroup(props.setSelectedFacilityType, facilityType, "facility-type", props.selectedFacilityType);
  };

  const updateFacilityGroup = (callBackUpdateFacilityGroup: any, value: any, updatedField: string, previousState: string) => {
    let updatedFacilityObject = {
      facilityName: selectedFacility,
      county: props.selectedCounty,
      facilityType: props.selectedFacilityType,
      hospitalListGroup: props.selectedHospitalGroup,
    };

    if (updatedField === "county") {
      updatedFacilityObject.county = value;
    } else if (updatedField === "hospital-group") {
      updatedFacilityObject.hospitalListGroup = value;
    } else if (updatedField === "facility-type") {
      updatedFacilityObject.facilityType = value;
    }
    HospitalListCMService.updateFacilityDependentOptions(updatedFacilityObject).subscribe({
      next: (v) => {
        // const response = v.data.data.data;
        callBackUpdateFacilityGroup(value);
        setIsFacilityUpdated(!isFacilityUpdated);
        // console.log("update hospital list data");
        // console.log(v);
      },
      error: (e) => {
        callBackUpdateFacilityGroup(previousState);
        console.log(e);
      },
    });
    // callBackUpdateFacilityGroup(value);
  };

  const onAddNewFacility = (facilityData: string) => {
    setAddFacilityFirstLoad(false);
    setAddFacility(facilityData);
  };

  const validateFacility = () => {
    let validatedText = true;

    forEach(facilityOptionListValues, (facilityObj: any) => {
      if (facilityObj?.trim().toLowerCase() === addFacility?.trim()?.toLowerCase() || (!addFacilityFirstLoad && addFacility?.trim() === "")) validatedText = false;
    });

    return {
      validation: validatedText,
      error_message: addFacility?.trim() === "" ? "Facility is required!" : "Facility already exists!",
      disable: validatedText && addCounty?.trim() !== "" && addHospitalistGroup?.trim() !== "" && addTypeOfFacility?.trim() !== "",
    };
  };

  const onAddNewCounty = (facilityData: any) => {
    setAddCounty(facilityData);
  };

  const onAddNewHospitalistGroup = (facilityData: any) => {
    setaddHospitalistGroup(facilityData);
  };

  const onAddNewTypeOFFacility = (facilityData: any) => {
    setaddTypeOfFacility(facilityData);
  };

  const getFacilityDropDownEditMode = () => {
    return (
      <div key={1}>
        <div className="facility-dropdown-container">
          <div className="facility-dropdown-container__facility-select-container">
            <div className="facility-dropdown-container__facility-select-container--select-facility">
              <Select style={{ minWidth: 200, maxWidth: 550, fontSize: 20, fontWeight: 500, color: "#42526E" }} showSearch value={selectedFacility} onChange={onFacilityChange} bordered={false}>
                {facilityOptionListValues?.sort((a , b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1)?.map((option: any, index: any) => (
                  <Option value={option} key={option + index}>
                    {option}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="facility-dropdown-container__facility-select-container--add-facility">
              <CanEdit>
              <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                loading={false}
                onClick={() => {
                  setIsAddFacilityModalOpen(true);
                }}
                className="facility-dropdown-container__facility-select-container--add-btn"
              >
                Add Facility
              </Button>
              </CanEdit>
            </div>
          </div>

          <div className="facility-dropdown-container__county-select-container">
            <div className="facility-dropdown-container__county-select-container--county">
              <SelectDropDown
                options={facilityDependentOption.countyList}
                label={"County"}
                callBackDisable={disableEditableDropDown}
                disable={!dropdownEditEnabled}
                value={props.selectedCounty}
                onChange={onCountyChange}
              />
            </div>
            <div className="facility-dropdown-container__county-select-container--group">
              <SelectDropDown
                options={facilityDependentOption.facilityGroup}
                label={"Hospitalist Group"}
                callBackDisable={disableEditableDropDown}
                disable={!dropdownEditEnabled}
                value={props.selectedHospitalGroup}
                onChange={onHosptalGroupChange}
              />
            </div>
            <div className="facility-dropdown-container__county-select-container--type-of-facility">
              <SelectDropDown
                options={facilityDependentOption.facilityType}
                label={"Type of Facility"}
                callBackDisable={disableEditableDropDown}
                disable={!dropdownEditEnabled}
                value={props.selectedFacilityType}
                onChange={onFacilityTypeChange}
              />
            </div>
            <CanEdit>
            <div
              onClick={() => {
                setDropdownEditEnabled(!dropdownEditEnabled);
              }}
              className={classNames({
                "facility-dropdown-container__county-select-container--edit": true,
                // "facility-dropdown-container__county-select-container--edit-underline": dropdownEditEnabled,
              })}
            >
              {dropdownEditEnabled ? <span>Cancel Edit</span> : <span>Edit</span>}
            </div>
            </CanEdit>
          </div>
        </div>
      </div>
    );
  };

  const addNewFacilityData = () => {
    HospitalListCMService.addNewFacility({
      facilityName: addFacility,
      county: addCounty,
      hospitalListGroup: addHospitalistGroup,
      facilityType: addTypeOfFacility,
    }).subscribe({
      next: (v) => {
        setFacilityOptionList([...facilityOptionList, { county_name: addCounty, facility_name: addFacility, hosplst_grp_name: addHospitalistGroup, organization_name: addTypeOfFacility }]);
        setFacilityOptionListValues([...facilityOptionListValues, addFacility]);
        setIsAddFacilityModalLoading(false);
        setIsAddFacilityModalOpen(false);
      },
      error: (e) => {
        setIsAddFacilityModalLoading(false);
        setIsAddFacilityModalOpen(false);
      },
    });
  };

  return (
    <>
      {currentpageMode === "edit" && getFacilityDropDownEditMode()}
      {currentpageMode === "read" && (
        <div className="facility-container">
          <div className="facility-container__left-container">
            <SelectDropDown options={facilityOptionListValues} label={"Facility"} disable={false} value={selectedFacility} onChange={onFacilityChange} />
            <SelectDropDown
              options={facilityDependentOption.countyList}
              label={"County"}
              callBackDisable={disableEditableDropDown}
              disable={dropDownIsSelectable}
              value={props.selectedCounty}
              onChange={onCountyChange}
            />
            <SelectDropDown
              options={facilityDependentOption.facilityGroup}
              label={"Hospitalist Group"}
              callBackDisable={disableEditableDropDown}
              disable={dropDownIsSelectable}
              value={props.selectedHospitalGroup}
              onChange={onHosptalGroupChange}
            />
            <SelectDropDown
              options={facilityDependentOption.facilityType}
              label={"Type of Facility"}
              callBackDisable={disableEditableDropDown}
              disable={dropDownIsSelectable}
              value={props.selectedFacilityType}
              onChange={onFacilityTypeChange}
            />
          </div>
        </div>
      )}

      <Modal
        wrapClassName="facility-container__add-Facility-container"
        title="Add Facility"
        visible={isAddFacilityModalOpen}
        onCancel={() => {
          setIsAddFacilityModalOpen(false);
          setAddFacility("");
          setAddCounty("");
          setaddHospitalistGroup("");
          setaddTypeOfFacility("");
          setAddFacilityFirstLoad(true);
        }}
        onOk={() => {
          setAddFacilityFirstLoad(true);
          setIsAddFacilityModalLoading(true);
          addNewFacilityData();
          setAddFacility("");
          setAddCounty("");
          setaddHospitalistGroup("");
          setaddTypeOfFacility("");
        }}
        cancelButtonProps={{ hidden: true }}
        okButtonProps={{ disabled: !validateFacility()?.disable }}
        zIndex={1000}
        okText="Save"
        width={"35%"}
      >
        <Spin spinning={isAddFacilityModalLoading} indicator={<HealthemSpinner/>}>
          <div className="facility-container__add-Facility-container__row">
            <div className="facility-container__add-Facility-container__row__label">Facility</div>
            <div className="facility-container__add-Facility-container__row__input-container">
              <Input
                className="facility-container__add-Facility-container__row__input-container__input"
                value={addFacility}
                status={!validateFacility()?.validation ? "error" : ""}
                onChange={(e) => {
                  onAddNewFacility(e.target.value);
                }}
              />
              {!validateFacility()?.validation ? (
                <span className="facility-container__add-Facility-container__row__input-container__input__error-message-container">
                  <span className="facility-container__add-Facility-container__row__input-container__input__error-message-container__error-icon">
                    <Icon name="hrainfo" />
                  </span>
                  {validateFacility()?.error_message}
                </span>
              ) : null}
            </div>
          </div>
          <div className="facility-container__add-Facility-container__row">
            <div className="facility-container__add-Facility-container__row__label">County</div>
            <SelectDropDown options={facilityDependentOption.countyList} width={"50%"} value={addCounty} onChange={onAddNewCounty} />
          </div>
          <div className="facility-container__add-Facility-container__row">
            <div className="facility-container__add-Facility-container__row__label">Hospitalist Group</div>
            <SelectDropDown options={facilityDependentOption.facilityGroup} width={"50%"} value={addHospitalistGroup} onChange={onAddNewHospitalistGroup} />
          </div>
          <div className="facility-container__add-Facility-container__row">
            <div className="facility-container__add-Facility-container__row__label">Type of Facility</div>
            <SelectDropDown options={facilityDependentOption.facilityType} width={"50%"} value={addTypeOfFacility} onChange={onAddNewTypeOFFacility} />
          </div>
        </Spin>
      </Modal>
    </>
  );
};

const MappingTabs = (props: any) => {
  const { TabPane } = Tabs;

  enum tabKeyName {
    hospitalists = "1",
    hospitalCaseManager = "2",
    payerCaseManager = "3",
  }

  const activeTab = useHospitalMappingStore((state) => state.activeTab);
  const setActiveTab = useHospitalMappingStore((state) => state.setActiveTab);
  // const hospitalListTabData = useHospitalMappingStore((state) => state.hospitalListTabData);
  const setHospitalListTabData = useHospitalMappingStore((state) => state.setHospitalListTabData);
  const hospitalListTabColumnConfig = useHospitalMappingStore((state) => state.hospitalListTabColumnConfig);
  const setHospitalListTabColumnConfig = useHospitalMappingStore((state) => state.setHospitalListTabColumnConfig);
  const selectedHospitalListFacility = useGlobalInformationStore((state) => state.selectedHospitalListFacility);
  // const setSelectedHospitalListFacility = useGlobalInformationStore((state) => state.setSelectedHospitalListFacility);
  const setIsHospitalListLoading = useHospitalMappingStore((state) => state.setIsHospitalListLoading);
  const isFacilityUpdated = useHospitalMappingStore((state) => state.isFacilityUpdated);
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);
  const setIsHospitalListTabColumnConfigLoaded = useHospitalMappingStore((state) => state.setIsHospitalListTabColumnConfigLoaded);

  const [hospitalListState, setHospitalState] = useState<any>([]);
  const [caseManagerListState, setCaseManagerListState] = useState<any>([]);
  const [payorCaseManagerListState, setPayorCaseManagerListState] = useState<any>([]);

  useEffect(() => {
    console.log("MappingTabs.useEffect");
    setIsHospitalListLoading(true);
    if (isEmpty(hospitalListTabColumnConfig)) {
      getColumnConfig();
    }
    setHospitalState([]);
    setCaseManagerListState([]);
    setPayorCaseManagerListState([]);
    getHospitalAndCm();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHospitalListFacility, isFacilityUpdated]);

  const getHospitalAndCm = async () => {
    console.log("MappingTabs.getHospitalAndCm");
    let facilityName: string;
    if (!(selectedHospitalListFacility === undefined || selectedHospitalListFacility === "" || selectedHospitalListFacility === null)) {
      facilityName = selectedHospitalListFacility;
    } else {
      facilityName = "";
    }
    if (facilityName !== "") {
      await HospitalListCMService.fetchHospitalMapping(facilityName, currentpageMode).subscribe({
        next: (v) => {
          // const response = v?.data?.data?.data;
          setHospitalListTabData(v.data.data.data);
          setHospitalState(v?.data?.data?.data?.hospitalList);
          setCaseManagerListState(v?.data?.data?.data?.caseManagerList);
          setPayorCaseManagerListState(v?.data?.data?.data?.payorCaseManagerList);
          props.setSelectedCounty(v?.data?.data?.data?.facilityInfo.length > 0 ? v?.data?.data?.data?.facilityInfo[0]?.county_name : "");
          props.setSelectedHospitalGroup(v?.data?.data?.data?.facilityInfo.length > 0 ? v?.data?.data?.data?.facilityInfo[0]?.hosplst_grp_name : "");
          props.setSelectedFacilityType(v?.data?.data?.data?.facilityInfo.length > 0 ? v?.data?.data?.data?.facilityInfo[0]?.organization_name : "");
          setIsHospitalListLoading(false);
        },
        error: (e) => {
          console.log(e);
        },
      });
    }
  };

  const getColumnConfig = async () => {
    console.log("MappingTabs.getColumnConfig");
    setIsHospitalListTabColumnConfigLoaded(true);
    await HospitalListCMService.fetchHospitalCMColumnConfig().subscribe({
      next: (v) => {
        setHospitalListTabColumnConfig(v?.data?.data?.data);
        setIsHospitalListTabColumnConfigLoaded(false);
      },
      error: (e) => {
        console.log(e);
        setIsHospitalListTabColumnConfigLoaded(true);
      },
    });
  };

  const onChangeTab = (key: string) => {
    setActiveTab(key);
  };

  //d1={ hospitalListState } d2 ={ caseManagerListState } d3 = {payorCaseManagerListState}

  return (
    <div className="hospitalList-component__tab-container">
      <Tabs className="facility-info__facility-info-tabs tab-menu" activeKey={activeTab} onChange={onChangeTab} type="card">
        <TabPane tab={<div className="ui-program-name">Hospitalists</div>} key={tabKeyName.hospitalists} className="ui-program">
          <HospitalListTable
            column={hospitalListTabColumnConfig?.hospitalListTab ? hospitalListTabColumnConfig?.hospitalListTab : []}
            data={hospitalListState}
            setData={setHospitalState}
            hospitalData={hospitalListState}
            caseManagerData={caseManagerListState}
            payorCaseManager={payorCaseManagerListState}
            hospitalSetData={setHospitalState}
            caseManagerSetData={setCaseManagerListState}
            payorCaseManagerSetData={setPayorCaseManagerListState}
          />
        </TabPane>

        <TabPane tab={<div className="ui-program-name">Hospital Case Manager</div>} key={tabKeyName.hospitalCaseManager} className="ui-program">
          <CaseManagerListTable
            column={hospitalListTabColumnConfig?.caseManagerTab ? hospitalListTabColumnConfig?.caseManagerTab : []}
            data={caseManagerListState}
            setData={setCaseManagerListState}
            hospitalData={hospitalListState}
            caseManagerData={caseManagerListState}
            payorCaseManager={payorCaseManagerListState}
            hospitalSetData={setHospitalState}
            caseManagerSetData={setCaseManagerListState}
            payorCaseManagerSetData={setPayorCaseManagerListState}
          />
        </TabPane>

        <TabPane tab={<div className="ui-program-name">Payor Case Manager</div>} key={tabKeyName.payerCaseManager} className="ui-program">
          <PayorCaseManagerListTable
            column={hospitalListTabColumnConfig?.payorCaseManagerTab ? hospitalListTabColumnConfig?.payorCaseManagerTab : []}
            data={payorCaseManagerListState}
            setData={setPayorCaseManagerListState}
            hospitalData={hospitalListState}
            caseManagerData={caseManagerListState}
            payorCaseManager={payorCaseManagerListState}
            hospitalSetData={setHospitalState}
            caseManagerSetData={setCaseManagerListState}
            payorCaseManagerSetData={setPayorCaseManagerListState}
          />
        </TabPane>
      </Tabs>
      {props.noFacilityErrorMesage ? (
        <div className="facility-container__error-message-for-no-facility">
          <span className="facility-container__error-message-for-no-facility__asterisk">*</span>
          <span className="facility-container__error-message-for-no-facility__message">{`${props.noFaciityName} is not part of the Contact Matrix list, contact Admin to add.`}</span>
        </div>
      ) : null}
    </div>
  );
};

const SelectDropDown = (props: any) => {
  return (
    <div
      className="facility-container__hospitalListSelectDropDown"
      style={{ width: `${props.width ? props.width : "17vw"}` }}
      onClick={() => {
        if (props.callBackDisable) {
          props.callBackDisable();
        }
      }}
    >
      {props?.label ? <div className="facility-container__hospitalListSelectDropDown__label">{props.label}</div> : null}
      <div className="facility-container__hospitalListSelectDropDown__dropDown">
        <Select showSearch disabled={props.disable} style={{ width: `${props.width ? "100%" : "15vw"}` }} value={props?.value} onChange={(value) => props.onChange(value)}>
          {props?.options?.map((option: any, index: any) => (
            <Option value={option} key={option + index}>
              {option}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default FacilityInfo;
